class Application {
    getAppLocations(appLocations) {
        if (!_.isEmpty(appLocations)) {
            const locations = JSON.parse(appLocations);

            return _.map(locations, data => {
                const spaceIndex = data.indexOf(' ');

                return {
                    code: parseInt(data.substr(0, spaceIndex)),
                    location: data.substring(spaceIndex + 1)
                }
            });
        }
    }

    getAppCodeByLocation(location) {
        const result = _.find(QX7Rule.appLocations, {location });
        if (!result) return;

        return result.code.toString();
    }

    getBrandLogoAppLocations(brandLocations) {
        if (!_.isEmpty(brandLocations)) {
            return JSON.parse(JSON.parse(brandLocations));
        }
    }

    getSettingsByLocation(location) {
        const code = this.getAppCodeByLocation(location);
        const freeApps = _.filter(ub.current_material.settings.applications, { application_type: "free" });
        let settings = _.find(freeApps, { code: code.toString() });

        if (!settings) return;
        return JSON.parse(JSON.stringify(settings));;
    }

    getAvailableLocations() {
        const locations = [];

        _.each(QX7Rule.appLocations, loc => {
            if (ub.current_material.settings.applications[loc.code]) {
                locations.push(loc);
            } else {
                console.error(`No free application is set for [${loc.code}] ${loc.location}`)
            }
        });

        return locations;
    }

    getAppPerspective(views) {
        const isPrimaryViews = [];
        let view = "";

        _.each(views, (view) => {
            if (view.application && view.application.isPrimary) {
                isPrimaryViews.push(view.perspective);
            }
        });

        if (isPrimaryViews.length) {
            isPrimaryViews.length > 1 && console.error('isPrimary flag is redundant');
            isPrimaryViews.length === 1 && (view = isPrimaryViews[0]);
        }

        return view;
    }

    newApplication(location, type, artOnly, customAddition=false) {
        const newApp = this.getSettingsByLocation(location);
        const newID = ub.funcs.getNewCustomID();
        let newIDStr = newID.toString();

        newApp.code = newIDStr;
        newApp.application.id = newIDStr;
        newApp.configurationSource = "Added";
        newApp.zIndex = ub.funcs.getNewZIndex();
        newApp.perspective = this.getAppPerspective(newApp.application.views);
        newApp.status = "on";


        if (ub.config.pageType === "Order Editor") {
            ub.funcs.addDefaultApplicationSize(newApp);
        }

        const isSingleView = ub.data.categoriesWithSingleViewApplications.getItem(ub.config.sport, ub.config.type, ub.config.blockPattern, ub.config.option);
        if (isSingleView) {
            newApp.application.views = _.filter(newApp.application.views, function (view) {
                return view.application.isPrimary === 1;
            });
        }

        newApp.application.name = location;

        const part = newApp.application.layer;
        if (typeof ub.data.applications_transformed[part] !== 'undefined') {
            ub.data.applications_transformed[part][newIDStr] = newApp.application;
        }

        ub.current_material.settings.applications[newIDStr] = newApp;
        ub.data.applications_transformed_one_dimensional[newIDStr] = newApp.application;

        // TODO: refactor
        ub.funcs.renderLocations(newIDStr);
        $('div.optionButton[data-type="' + type + '"]').trigger('click'); // 😥
        // TODO: refactor

        ub.funcs.pushOldState('add location', 'application', newApp, {applicationID: newIDStr});
        ub.data.newApplication = newApp;

        ub.funcs.setActiveView(newApp.perspective);

        if (type === "embellishments") {
            ub.data.isEditing = false;

            if (typeof artOnly !== "undefined") {
                CreateUploadInksoft.events.init();
            } else {
                InksoftMascot.events.onShowStockMascot();
            }
        }

        // Custom Addition `Face Mask (Quickturn)``
        // for player_number, team_name, and player_name only
        if (customAddition) {
            newApp.customAddition = true;
        }

        if (_.contains(ub.fontGuideIDs, ub.valid)) {
            if (newApp.application_type === "mascot") {
                ub.funcs.createMascotPopup(null, newApp.mascot, newApp);
            }
        }
    }

    cloneAppSettings(location, refSettings, callback) {
        const freeApp = this.getSettingsByLocation(location);
        const refApp = JSON.parse(JSON.stringify(refSettings));

        refApp.application = freeApp.application;

        const newID = ub.funcs.getNewCustomID();
        let newIDStr = newID.toString();

        refApp.code = newIDStr;
        refApp.application.id = newIDStr;
        refApp.configurationSource = "Added";
        refApp.zIndex = ub.funcs.getNewZIndex();
        refApp.perspective = this.getAppPerspective(refApp.application.views);
        refApp.status = "on";

        ub.current_material.settings.applications[refApp.code] = refApp;

        callback(refApp);
    }
}